import styled from "styled-components";
import { Input } from "../../components/input/Input";
import { Spacer } from "./Spacer";
import { TextCapitalized } from "./text/TextCapitalized";

interface HourMinuteInputProps {
  value: Date;
  onChange: (value: Date) => void;
  error?: boolean;
}

const pad = (value: number) => String(value).padStart(2, "0");

const parseTimeUnit = (raw: string, max: number) => {
  const digits = raw.replace(/\D/g, "").slice(-2);
  if (digits === "") return 0;
  return Math.min(Number(digits), max);
};

export const HourMinuteInput = (props: HourMinuteInputProps) => {
  const setHours = (raw: string) => {
    const next = new Date(props.value);
    next.setHours(parseTimeUnit(raw, 23));
    props.onChange(next);
  };

  const setMinutes = (raw: string) => {
    const next = new Date(props.value);
    next.setMinutes(parseTimeUnit(raw, 59));
    props.onChange(next);
  };

  return (
    <StyledContainer>
      <Input
        value={pad(props.value.getHours())}
        onChange={(e) => setHours(e.target.value)}
        type="text"
        inputMode="numeric"
        noneBottomSpacer
        error={props.error ? "" : undefined}
      />
      <Spacer x={1} />
      <TextCapitalized>:</TextCapitalized>
      <Spacer x={1} />
      <Input
        value={pad(props.value.getMinutes())}
        onChange={(e) => setMinutes(e.target.value)}
        type="text"
        inputMode="numeric"
        noneBottomSpacer
        error={props.error ? "" : undefined}
      />
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
`;
